import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { StyledDivider } from "./ObjectDevicesCard.styled";
import { SubscriptionIcon } from "assets/icons";

export interface SectionSubscriptionsProps {
  subscriptionName: string | undefined;
}

const SectionSubscriptions: FC<SectionSubscriptionsProps> = ({
  subscriptionName
}) => {
  if (!subscriptionName) return null;
  return (
    <>
      <StyledDivider />

      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={2}
        >
          <SubscriptionIcon />

          <Typography fontSize={14} fontWeight={400} color={"#646D7B"}>
            Subscription:
          </Typography>

          <Typography
            variant="h6"
            fontSize={14}
            fontWeight={500}
            color={"#000"}
          >
            {subscriptionName}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export default SectionSubscriptions;
